import { PublicReadError, publicGet } from "@/shared/http/public-http";
import type { Category } from "../types/category.dto";

/**
 * GET /category — árvore hierárquica de categorias ativas, já com `children`
 * (recursivo) e banners. Leitura pública anônima (ver `public-http.ts`) —
 * chamada tanto do servidor (home, trilha da PLP) quanto do browser (painel de
 * categorias do header).
 *
 * Só categorias ativas: o antigo `includeInactive` foi removido da API.
 */
export async function getCategories(): Promise<Category[]> {
    return publicGet<Category[]>("/category", { tags: ["categories"] });
}

/** "Não existe" (404) — o ÚNICO erro de leitura que pode virar `notFound()`. */
export function isCategoryNotFound(error: unknown): boolean {
    return error instanceof PublicReadError && error.status === 404;
}
